<template>
  <div class="mix-notes">
    <Note
      v-for="note in sortedNotes"
      :note="note"
      :owns-mix="ownsMix"
      :key="note.id"
      :indent="0"
      :version="showVersion ? note.mix_version : null"
      :currentTime="currentTime"
      :highlight="note.id == highlightedNote"
      @noteReaction="noteReaction($event)"
      @play-at-time="$emit('play-at-time', $event)"
      @note-mouseenter="$emit('note-mouseenter', $event)"
      @note-mouseleave="$emit('note-mouseleave', $event)"
    >
    </Note>
    <div v-if="nCompleted > 0 && !hideCompleteOption" class="show-completed form-check">
      <input
        class="form-check-input"
        type="checkbox"
        @change="showCompleted = !showCompleted"
        id="show-completed-checkbox"
      />
      <label class="form-check-label" for="show-completed-checkbox">Show {{ nCompleted }} completed note(s)</label>
    </div>
  </div>
</template>
<style scoped>
.mix-notes {
  padding-bottom: 8px;
  min-height: 56px;
}
@media (min-width:992px) {
  .show-completed {
    margin-left: 50px;
    margin-top: 5px;
  }
}
</style>

<script>
import Note from "./note.vue"
import { formatISO, parseJSON, compareAsc } from "date-fns"
import { post_csrf } from '../utils/csrf'
import { buildNote } from "./note_store"

const parseNoteJSON = function (json) {
  const note = Object.assign({}, json)
  return note
}

export default {
  props: [
    "notes",
    "highlightedNote",
    "mix-id",
    "owns-mix",
    "hide-create",
    "show-version",
    "current-time",
    "hide-complete-option"
  ],
  data: function () {
    return {
      showCompleted: false,
    }
  },
  components: { Note },
  computed: {
    sortedNotes: function () {
      var sorted = this.notes.filter(note => !note.parent_note_id)

      sorted = sorted.filter(n => !n.deleted)
      if (!this.showCompleted) {
        sorted = sorted.filter(n => !n.completed)
      }

      sorted.sort((a, b) => compareAsc(b.created_at, a.created_at))

      if (!this.hideCreate && (!sorted[0] || !sorted[0].editing)) {
        sorted.unshift(buildNote({ mix_id: this.mixId }))
      }

      return sorted
    },
    nCompleted: function () {
      return this.notes.filter(n => !n.parent_note_guid && !n.deleted && n.completed).length
    },
  },
}
</script>
